import { Dimensions } from 'react-native';

export const breakpoints = {
  xs: 320,    
  sm: 360,  
  md: 375,  
  lg: 414,  
  xl: 768   
};

export const getScreenWidth = () => Dimensions.get('window').width;

export const getBreakpoint = (width: number) => {
  if (width < breakpoints.sm) return 'xs';
  if (width < breakpoints.md) return 'sm';
  if (width < breakpoints.lg) return 'md';
  if (width < breakpoints.xl) return 'lg';
  return 'xl';
};

export const isSmallScreen = (width: number) => width < breakpoints.md;
export const isLargeScreen = (width: number) => width >= breakpoints.lg;
export const isTablet = (width: number) => width >= breakpoints.xl;
export const is320px = (width: number) => width === 320;


export const getResponsiveStyle = (width: number, styles: any) => {
  const breakpoint = getBreakpoint(width);
  return {
    ...styles.base,
    ...(styles[breakpoint] || {})
  };
};


export const isXs = (width: number) => width < breakpoints.sm; // < 360
export const isSm = (width: number) => width >= breakpoints.sm && width < breakpoints.md; // 360-374
export const isMd = (width: number) => width >= breakpoints.md && width < breakpoints.lg; // 375-413
export const isLg = (width: number) => width >= breakpoints.lg && width < breakpoints.xl; // 414-767
export const isXl = (width: number) => width >= breakpoints.xl; // >= 768


export const getConditionalStyles = (width: number, styleMap: any) => {
  const conditionalStyles = [];
  

  if (styleMap.base) conditionalStyles.push(styleMap.base);
  

  if (isXs(width) && styleMap.xs) conditionalStyles.push(styleMap.xs);
  if (isSm(width) && styleMap.sm) conditionalStyles.push(styleMap.sm);
  if (isMd(width) && styleMap.md) conditionalStyles.push(styleMap.md);
  if (isLg(width) && styleMap.lg) conditionalStyles.push(styleMap.lg);
  if (isXl(width) && styleMap.xl) conditionalStyles.push(styleMap.xl);
  

  if (styleMap[width]) conditionalStyles.push(styleMap[width]);
  
  return conditionalStyles;
};
